import "./Contact.module.css";
import PureDetailHeader from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import PureDetailFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <PureDetailHeader />
      <GetInTouch />
      <PureDetailFooter />
    </div>;
}